import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function OfferSection() {
  return <section id="offer" className="py-10 md:py-16 bg-brand-dark text-white relative overflow-hidden" data-id="element-96">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-blue via-transparent to-transparent" data-id="element-97"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/10 backdrop-blur-md p-6 md:p-10 rounded-[2rem] border border-white/20 shadow-2xl" data-id="element-99">
          <h2 className="text-2xl md:text-4xl font-bold mb-4" data-id="element-100">
            Get the complete <br className="hidden md:block" data-id="element-101" />
            <span className="text-brand-orange" data-id="element-102">
              Toddler Travel Survival Kit
            </span>{' '}
            today.
          </h2>

          <p className="text-lg text-gray-300 mb-6" data-id="element-103">
            No subscriptions, no hidden fees. Just the peace of mind that comes
            with being prepared.
          </p>

          <div className="mb-8" data-id="element-104">
            <div className="inline-block px-4 py-1 bg-red-500 text-white text-sm font-bold rounded-full mb-3 animate-pulse" data-id="element-105">
              🔥 Promoción Limitada
            </div>
            <div className="flex items-center justify-center gap-3" data-id="element-106">
              <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-107">
                $33
              </span>
              <span className="text-5xl font-extrabold text-white" data-id="element-108">$6.39</span>
            </div>
            <div className="text-brand-lightBlue text-sm uppercase tracking-widest font-bold mt-2" data-id="element-109">
              (Less than the cost of one overpriced airport meal 🍔)
            </div>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-110">
            <Button onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'Toddler Travel Survival Kit',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
            window.open('https://mjebook.com/cart/43139516498038:1', '_blank');
          }} className="w-full sm:w-auto text-lg px-10 py-4 shadow-orange-500/30 shadow-xl" data-id="element-111">
              Get the Survival Kit Now
            </Button>
            <p className="text-gray-400 text-sm flex items-center gap-2" data-id="element-112">
              <span data-id="element-113">⚡️</span> Instant digital delivery. Start prepping your
              peaceful trip in 30 seconds.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}